<template>
    <div class="text-center">
        <v-dialog
            v-model="show"
            width="unset"
            max-width="500"
            tabindex="-1"
            role="dialog"
            transition="v-expand-y-transition"
            persistent
        >
            <v-card
                class="elevation-12"
                max-width="330px"
                transition="v-expand-y-transition"
            >
                <v-container class="pa-7 text-center">
                    <div class="d-flex justify-center mb-6">
                        <v-img
                            src="/svg/undraw_high_five_re_jy71.svg"
                            max-width="170"
                        />
                    </div>
                    <h4>To Send Money</h4>
                    <v-btn
                        :to="{
                            name: 'user-settings',
                            hash: '#payment-methods',
                        }"
                        color="primary"
                        class="text-none white--text rounded-lg mb-3"
                        depressed
                        small
                        block
                        dark
                        @click="show = false"
                    >
                        Click To Add Payment Method
                    </v-btn>

                    <h4>To Receive Money</h4>
                    <v-btn
                        :to="{
                            name: 'user-settings',
                            hash: '#delivery-method',
                        }"
                        color="primary"
                        class="text-none white--text rounded-lg"
                        outlined
                        small
                        block
                        dark
                        @click="show = false"
                    >
                        {{ $_userCanPostOffers ?  'Add Debit card' : 'Add Bank Account' }}
                    </v-btn>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: Boolean,
                required: true,
            },
        },
        computed: {
            show: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                },
            },
        },
    };
</script>
